import { makeStyles } from '@mui/styles';
import classNames from 'clsx';
import Container from 'components/Container/Container';
import LoginIcon from '@mui/icons-material/Login';
import AccountIcon from '@mui/icons-material/AccountCircle';
// import LogoSymbol from 'components/Img/bpx-logo.png';
// import LogoSymbolWhite from 'components/Img/bpxwhite.png';
import LogoSymbolWhite from 'components/Img/bpxwhite.png';
import PropTypes from 'prop-types';
import { cloneElement, memo, useRef, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import qs from 'qs';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import ReactCountryFlag from 'react-country-flag';
import { useAppSelector } from 'hooks/redux';

import {
  AppBar,
  Button,
  CircularProgress,
  Toolbar,
  Typography,
  useScrollTrigger,
  Alert,
} from '@mui/material';
import { green } from '@mui/material/colors';
import { useTranslation } from '../../hooks/useTranslation';
import { useLocaleNew } from '../IntlProvider';

function ElevationScroll(props: any) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const delta = 10;

const getDocScroll = () => {
  const doc = document.documentElement;
  const left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  return { top, left };
};

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
    },
    grow: {
      flex: '1 1 auto',
    },
    logoHeader: {
      marginTop: -20,
      width: 145,
      paddingLeft: 5,
      paddingRight: 5,
      borderRadius: 5,
      fill: '#ffffff',
      backgroundColor: 'transparent',
    },
    headerRoot: {
      // background: '#fff',
      background: 'rgba(255,255,255,.97)',
      border: 0,
      boxShadow: 'none',
    },
    headerWrap: {
      color: 'rgba(0,0,0,.54)',
      fontSize: 16,
      fontFamily: [
        'wm-content-sans-serif-font',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        '"Open Sans"',
        '"Helvetica Neue"',
        'sans-serif',
      ].join(','),
      '-webkit-transition': '-webkit-transform .3s',
      transition: 'transform .3s',
      fallbacks: [
        { transition: '-webkit-transform .3s' },
        { transition: 'transform .3s, -webkit-transform .3s' },
      ],
      '-webkit-transform': 'translateY(0%)',
      transform: 'translateY(0%)',
    },
    headerBorder: {
      '-webkit-box-shadow': '0 2px 2px -2px rgba(0,0,0,.15)',
      boxShadow: '0 2px 2px -2px rgba(0,0,0,.15)',
    },
    toolbar: {
      marginTop: '20px',
      padding: 0,
      width: '100%',
    },
    toolbarYellow: {
      backgroundColor: '#fce900',
      '& $toolbar': {
        minHeight: 38,
        height: 38,
      },
    },
    toolbarTransparent: {
      position: 'relative',
      backgroundColor: 'transparent',
    },
    navUp: {
      '-webkit-transform': 'translateY(-100%)',
      transform: 'translateY(-100%)',
    },
    navDown: {},
    containerAfterOverlay: {
      position: 'relative',
      zIndex: 100,
    },
    separatorMainLogoContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    separatorMainLogo: {
      borderRight: '1px solid rgba(0,0,0,.15)',
      marginLeft: 15,
      marginRight: 20,
      height: 28,
      display: 'inline-block',
    },
    wrapperIsOnline: {
      position: 'fixed',
      overflow: 'visible',
      zIndex: 9999,
      top: 0,
      left: 0,
      right: 0,
      height: 50,
      lineHeight: '50px',
      '& ~ *': {
        transform: 'translateY(+45px)',
      },
    },
    containerIsOnline: {
      position: 'fixed',
      backgroundColor: '#ffa000',
      borderBottom: '1px solid red',
      color: '#fff',
      top: 0,
      left: 0,
      right: 0,
      height: 50,
      lineHeight: '50px',
      textAlign: 'center',
    },
    buttonDownConn: {
      position: 'relative',
      top: 50,
    },
    wrapperConn: {
      textAlign: 'center',
    },
    buttonProgress: {
      position: 'absolute',
      color: green[500],
      top: '50%',
      left: '50%',
      marginTop: 38,
      marginLeft: -12,
    },
    popper: {
      position: 'static',
      zIndex: 9999,
    },
    menuButton: {
      whiteSpace: 'nowrap',
      color: 'rgba(255,255,255,.75)',
      '&:hover': {
        color: 'rgba(255,255,255,1)',
      },
    },
    menuButtonBlack: {
      whiteSpace: 'nowrap',
      color: 'rgba(0,0,0,.75)',
      '&:hover': {
        color: 'rgba(0,0,0,1)',
      },
    },
    menuPaper: {},
    menuSectionWrapper: {
      borderWidth: 1,
      borderLeftStyle: 'solid',
      borderColor: '#f7f7f7',
    },
    menuItemSection: {
      color: '#000',
      opacity: 1,
      fontSize: 15,
      minHeight: 18,
      padding: 0,
      paddingLeft: 16,
      paddingRight: 16,
      paddingBottom: 8,
      fontWeight: 'bold',
      '&.disabled': {
        opacity: 1,
      },
    },
    menuItem: {
      minHeight: 18,
      fontSize: 12,
      textTransform: 'uppercase',
      padding: 0,
      paddingLeft: 16,
      paddingRight: 16,
    },
    langMenu: {
      position: 'absolute',
      zIndex: 99,
      background: '#fff',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    containerLangs: {
      height: '100%',
    },
    containerLangsGrid: {
      height: '100%',
    },
    menuLang: {
      marginTop: 10,
    },
    textToolBarYellow: {
      fontSize: 12,
    },
    iconFlag: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginRight: theme.spacing(1),
    },
    searchButton: {
      color: '#fff',
    },
    boxSearch: {
      width: 0,
      transition: 'width 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    boxSearchOpen: {
      width: 300,
    },
    leftDivSearch: {
      transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    leftDivSearchOpen: {
      transform: 'translateX(-500px)',
      opacity: 0,
      width: 0,
    },
    headerStatic: {
      background: 'rgba(0,0,0, 0.3)',
      zIndex: 99,
      // boxShadow: 'none'
    },
    toolbarLang: {
      textAlign: 'right',
      color: '#fff',
      paddingTop: 5,
    },
    buttonLang: {
      color: '#fff',
      borderColor: '#fff',
      textTransform: 'capitalize',
      lineHeight: 'normal',
      backgroundColor: 'rgba(255,255,255, 0.4)',
      '&:hover': {
        borderColor: 'rgba(255,255,255, 0.4)',
      },
    },
    topbarFlagSelector: {
      position: 'relative',
      display: 'inline-block',
      height: '100%',
    },
    topbarFlagTrigger: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '8px 12px',
      height: '100%',
      minWidth: '44px',
      borderRadius: '6px',
      transition: 'all 0.2s ease',
      position: 'relative',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
      '&:focus': {
        outline: '2px solid #007bff',
        outlineOffset: '2px',
      },
    },
    flagIcon: {
      fontSize: '20px',
      lineHeight: 1,
      userSelect: 'none',
    },
    topbarDropDownOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 998,
      background: 'transparent',
    },
    topbarFlagMenu: {
      position: 'absolute',
      top: 'calc(100% + 8px)',
      right: 0,
      background: 'white',
      border: '1px solid #e1e5e9',
      borderRadius: '8px',
      zIndex: 999,
      minWidth: '160px',
      overflow: 'hidden',
    },
    topbarFlagItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      width: '100%',
      padding: '12px 16px',
      background: 'none',
      border: 'none',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '14px',
      color: '#333',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
      '&:focus': {
        backgroundColor: '#f8f9fa',
        outline: 'none',
      },
      '&.active': {
        backgroundColor: '#e3f2fd',
        color: '#007bff',
      },
    },
    languageName: {
      flex: 1,
      fontWeight: 500,
    },
    activeIndicator: {
      color: '#007bff',
      fontSize: '8px',
      marginLeft: 'auto',
    },
    '@media (max-width: 768px)': {
      topbarFlagMenu: {
        right: '-8px',
        minWidth: '140px',
      },
      topbarFlagItem: {
        padding: '14px 16px',
        fontSize: '16px',
      },
      flagIcon: {
        fontSize: '18px',
      },
    },
    alert: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginTop: theme.spacing(1),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginBottom: theme.spacing(1),
    },
  }),
  { name: 'HeaderApp' }
);

let didScroll = false;
let interval = false;
let lastScrollTop = 0;
let navbarHeight = 0;
const timeout = false;

const HeaderApp = memo((props) => {
  const {
    // logout = () => { },
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isOnline' does not exist on type '{ chil... Remove this comment to see the full error message
    isOnline = true,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isOnlineLoading' does not exist on type ... Remove this comment to see the full error message
    isOnlineLoading = false,
    // position = 'static',
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'user' does not exist on type '{ children... Remove this comment to see the full error message
    user = null,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'separatorMainLogo' does not exist on typ... Remove this comment to see the full error message
    separatorMainLogo = false,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isOnlineAction' does not exist on type '... Remove this comment to see the full error message
    isOnlineAction,
  } = props;

  const languages = {
    'pt-BR': { flag: 'https://flagcdn.com/w20/br.png', name: 'language.menu.br' },
    'en-US': { flag: 'https://flagcdn.com/w20/us.png', name: 'language.menu.en' },
    'es-ES': { flag: 'https://flagcdn.com/w20/es.png', name: 'language.menu.es' },
  };

  const [isOpenMenuLanguage, setIsOpenMenuLanguage] = useState(false);
  const selectorLanguageRef = useRef(null);

  const location = useLocation();

  // @ts-expect-error ts-migrate(2339)
  const { changeLocale } = useLocaleNew();

  const { t, locale } = useTranslation();

  // Close Dropdown on click outside
  useEffect(() => {
    const handleClickOutsied = (event) => {
      if (selectorLanguageRef.current && !selectorLanguageRef.current.contains(event.target)) {
        setIsOpenMenuLanguage(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpenMenuLanguage(false);
      }
    };

    if (isOpenMenuLanguage) {
      document.addEventListener('mousedown', handleClickOutsied);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutsied);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpenMenuLanguage]);

  const { search, pathname } = location;
  const lastPart = pathname.split('/').slice(-1)[0];
  const isDocs = lastPart === 'docs';

  const classes = useStyles();
  const navbar = useRef();
  const [state, setState] = useState({
    openSearch: false,
    drawer: {
      top: false,
      left: false,
      bottom: false,
      right: false,
    },
    wordsSelected: 0,
    anchorEl: null,
    anchorElPublication: null,
    scrollUp: false,
    navbarBorder: false,
    position: 'fixed',
    disableHidden: false,
    demoMode: false,
    menuOpen: false,
    openLangMenu: false,
  });

  const handleScroll = () => {
    didScroll = true;
  };

  const accountByDomain = useAppSelector((rstate) => rstate.accounts.result.accountByDomain?.[0]);

  const hasScrolled = () => {
    const { scrollUp } = state;
    const st = getDocScroll().top;

    if (!scrollUp) {
      if (st < navbarHeight) {
        setState((prev) => ({
          ...prev,
          scrollUp: true,
          st,
          navbarBorder: false,
        }));
      }
    }
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) {
      return;
    }
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      setState((prev) => ({ ...prev, scrollUp: false, st }));
      // navbar.current.classList.remove(classes.navDown);
      // navbar.current.classList.add(classes.navUp);
    } else if (st + window.innerHeight < document.body.clientHeight) {
      // Scroll Up
      setState((prev) => ({
        ...prev,
        scrollUp: true,
        navbarBorder: st > navbarHeight,
        st,
      }));
      // navbar.current.classList.remove(classes.navUp);
      // navbar.current.classList.add(classes.navDown);
    }

    lastScrollTop = st;
  };

  useEffect(() => {
    didScroll = true;
    if (navbar.current) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      navbarHeight = navbar.current.clientHeight;
      window.addEventListener('scroll', handleScroll);
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Timer' is not assignable to type 'boolean'.
      interval = setInterval(() => {
        if (didScroll) {
          hasScrolled();
          didScroll = false;
        }
      }, 50);
    }

    return () => {
      // unmount
      if (timeout) {
        clearTimeout(timeout);
      }
      if (interval) {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        clearInterval(interval);
      }
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'true' is not assignable to type 'undefined'.
      mounted.current = true;
    } else {
      window.removeEventListener('scroll', handleScroll);
      window.addEventListener('scroll', handleScroll);
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Timer' is not assignable to type 'boolean'.
      interval = setInterval(() => {
        if (didScroll) {
          hasScrolled();
          didScroll = false;
        }
      }, 50);
    }
  });

  // const {
  //   scrollUp, navbarBorder, openSearch, st
  // } = state;

  // const headerClassname = classNames('_headerWrapGlobal', classes.headerWrap, {
  //   [classes.navUp]: scrollUp && st < navbarHeight + 100,
  //   [classes.navDown]: !scrollUp && st > navbarHeight,
  //   [classes.headerBorder]: navbarBorder
  // });

  const query = qs.parse(search, { ignoreQueryPrefix: true });

  return (
    <>
      <div className={classes.wrapperIsOnline}>
        <Alert
          variant="filled"
          severity="warning"
          icon={false}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          Our platform has been updated with a new interface and improved performance. If you
          experience any difficulties during this transition, we encourage you to contact us.
        </Alert>
      </div>
      {!isOnline && (
        <div className={classes.wrapperIsOnline}>
          <div className={classes.containerIsOnline}>
            {isOnlineLoading ? 'Restablishing connection' : 'Your connection is down'}
          </div>
          <div className={classes.wrapperConn}>
            <Button
              disabled={isOnlineLoading}
              className={classes.buttonDownConn}
              onClick={() => {
                isOnlineAction();
              }}
              variant="outlined"
              size="small"
              color="primary"
            >
              {isOnlineLoading ? 'Reconnecting...' : 'Reconnect'}
            </Button>
            {isOnlineLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
        </div>
      )}
      <ElevationScroll>
        <AppBar
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          ref={navbar}
          className={classes.headerStatic}
          color="inherit"
          position={isDocs ? 'absolute' : 'fixed'}
        >
          <div className={classes.toolbarTransparent}>
            <Container size="publicationSize">
              <Toolbar className={classes.toolbar}>
                <Typography component="div" color="inherit">
                  <Link className={classes.title} to="/">
                    <img
                      alt="Alt"
                      src={accountByDomain?.themeLogo || LogoSymbolWhite}
                      className={classes.logoHeader}
                    />
                  </Link>
                </Typography>
                {!!separatorMainLogo && (
                  <div className={classes.separatorMainLogoContainer}>
                    <span className={classes.separatorMainLogo} />
                  </div>
                )}
                <Button
                  sx={{ display: { xs: 'none', md: 'inline-flex' } }}
                  className={classes.menuButton}
                  component={Link}
                  to="/login"
                >
                  {t('public.top.menu.start.shipping')}
                </Button>

                <Button
                  sx={{ display: { xs: 'none', md: 'inline-flex' } }}
                  className={classes.menuButton}
                  component={Link}
                  to="/tracking"
                >
                  {t('public.top.menu.tracking')}
                </Button>
                <Button
                  sx={{ display: { xs: 'none', md: 'inline-flex' } }}
                  className={classes.menuButton}
                  component={Link}
                  to="/docs"
                >
                  {t('public.top.menu.api')}
                </Button>
                <Button
                  sx={{ display: { xs: 'none', md: 'inline-flex' } }}
                  className={classes.menuButton}
                  component={Link}
                  to="/contact-us"
                >
                  {t('public.top.menu.contact.us')}
                </Button>
                <div className={classes.grow} />
                {isOpenMenuLanguage && (
                  <>
                    <Button
                      className={`${classes.menuButton} ${locale === 'en-US' ? 'active' : ''}`}
                      onClick={() => {
                        changeLocale('en-US');
                        setIsOpenMenuLanguage(false);
                      }}
                      title="en-US"
                    >
                      <img
                        loading="lazy"
                        width="20"
                        src={languages['en-US'].flag}
                        srcSet={languages['en-US'].flag}
                        alt="US"
                      />
                      <span className={classes.languageName}>
                        &nbsp;{t(languages['en-US'].name)}
                      </span>
                      {locale === 'en-US' && (
                        <span className={classes.activeIndicator}>&nbsp;●</span>
                      )}
                    </Button>

                    <Button
                      className={`${classes.menuButton} ${locale === 'es-ES' ? 'active' : ''}`}
                      onClick={() => {
                        changeLocale('es-ES');
                        setIsOpenMenuLanguage(false);
                      }}
                      title="es-ES"
                    >
                      <img
                        loading="lazy"
                        width="20"
                        src={languages['es-ES'].flag}
                        srcSet={languages['es-ES'].flag}
                        alt="ES"
                      />
                      <span className={classes.languageName}>
                        &nbsp;{t(languages['es-ES'].name)}
                      </span>
                      {locale === 'es-ES' && (
                        <span className={classes.activeIndicator}>&nbsp;●</span>
                      )}
                    </Button>

                    <Button
                      className={`${classes.menuButton} ${locale === 'pt-BR' ? 'active' : ''}`}
                      onClick={() => {
                        changeLocale('pt-BR');
                        setIsOpenMenuLanguage(false);
                      }}
                      title="pt-BR"
                    >
                      <img
                        loading="lazy"
                        width="20"
                        src={languages['pt-BR'].flag}
                        srcSet={languages['pt-BR'].flag}
                        alt="BR"
                      />
                      <span className={classes.languageName}>
                        &nbsp;{t(languages['pt-BR'].name)}
                      </span>
                      {locale === 'pt-BR' && (
                        <span className={classes.activeIndicator}>&nbsp;●</span>
                      )}
                    </Button>
                  </>
                )}
                <Button
                  className={classes.topbarFlagTrigger}
                  onClick={() => {
                    setIsOpenMenuLanguage(!isOpenMenuLanguage);
                  }}
                  aria-expanded={isOpenMenuLanguage}
                  aria-haspopup="true"
                >
                  <img
                    loading="lazy"
                    width="20"
                    src={
                      // @ts-expect-error ts-migrate(2339)
                      languages[locale].flag
                    }
                    srcSet={
                      // @ts-expect-error ts-migrate(2339)
                      languages[locale].flag
                    }
                    alt="BR"
                  />
                </Button>
                <div className={classNames(classes.leftDivSearch)}>
                  {!user && (
                    <Button
                      startIcon={<LoginIcon />}
                      className={classes.menuButton}
                      component={Link}
                      to={`/login${query.redirect ? `?redirect=${query.redirect}` : ''}`}
                    >
                      {t('public.top.menu.signin')}
                    </Button>
                  )}
                  {user ? (
                    <Button className={classes.menuButton} component={Link} to="/admin/dashboard">
                      {t('public.top.menu.service.panel')}
                    </Button>
                  ) : (
                    null && (
                      <Button
                        startIcon={<AccountIcon />}
                        className={classes.menuButton}
                        component={Link}
                        to="/register"
                      >
                        {t('public.top.menu.new.account')}
                      </Button>
                    )
                  )}
                </div>
              </Toolbar>
            </Container>
          </div>
        </AppBar>
      </ElevationScroll>
    </>
  );
});

// @ts-expect-error ts-migrate(2339) FIXME: Property 'propTypes' does not exist on type 'Named... Remove this comment to see the full error message
HeaderApp.propTypes = {
  separatorMainLogo: PropTypes.bool,
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.objectOf(PropTypes.any)]),
  // logout: PropTypes.func,
  isOnlineLoading: PropTypes.bool,
  // position: PropTypes.string,
  isOnline: PropTypes.bool,
  isOnlineAction: PropTypes.func.isRequired,
};

export default HeaderApp;
